// API 설정
// export const API_BASE_URL = 'https://localhost:7133';
export const API_BASE_URL = 'https://ranking.introduce.at'; 

// API 엔드포인트 재커밋 dd
export const API_ENDPOINTS = {//bareunplan
  // 시스템 API
  SYSTEM: {
    BJD_LIST: '/api/system/bjd-list',
    BJD_TREE: '/api/system/bjd-tree',
    RANKER_BJD_TREE: '/api/system/ranker-bjd-tree',
    RANKER_GUBUN_CODES: '/api/system/ranker-gubun-codes',
    RANKER_SCREEN_SETTINGS: '/api/system/ranker-screen-settings',
    RANKER_SCREEN_SETTINGS_SAVE: '/api/system/ranker-screen-settings/save',
    RANKER_SCREEN_SETTINGS_DEFAULT: '/api/system/ranker-screen-settings/default',
    RANKER_SCREEN_SETTINGS_DELETE: '/api/system/ranker-screen-settings/delete',
    RANKER_SCREEN_SETTINGS_REORDER: '/api/system/ranker-screen-settings/reorder',
    RANKER_FIX_ARTICLES: '/api/system/ranker-fix-articles',
    RANKER_DANJI_LIST: '/api/system/ranker-danji',
    RANKER_DANJI_COUNT: '/api/system/ranker-danji/count',
    RANKER_FIX_LIST: '/api/system/ranker-fix',
    RANKER_FIX_LIST_V2: '/api/system/ranker-fix-v2',
    RANKER_TOP_RANKINGS: '/api/system/ranker-top-rankings',
    RANKER_HOT_PLACES: '/api/system/ranker-hot-places',
    MAIN_SCREEN_SETTINGS: '/api/system/main-screen-settings',
    MAIN_SCREEN_SETTINGS_SAVE: '/api/system/main-screen-settings/save',
    RANKER_DANJI_DETAIL: '/api/system/ranker-danji',
    RANKER_WEEKLY_COMPARE: '/api/system/ranker-weekly-compare',
    REAL_TRANSACTIONS: '/api/system/real-transactions',
    REAL_TRANSACTIONS_MARKET: '/api/system/real-transactions-market',
    WEEKLY_LISTING_VOLUME: '/api/system/weekly-listing-volume',
    ASK_PRICE_CHART: '/api/system/ask-price-chart',
    ASK_PRICE_VOLUME_CHART: '/api/system/ask-price-volume-chart',
    RANKER_SCRAPING_RESULTS: '/api/system/ranker-scraping-results',
    RANKER_SCRAPING_MASTERS: '/api/system/ranker-scraping-masters',
    RANKING_SUMMARY: '/api/system/ranking-summary',
  },

  // KB API
  KB: {
    REGIONS: '/api/kb/regions',
    TOP_REGIONS: '/api/kb/top-regions',
    DATA_CHART_MULTI: '/api/kb/data/chart/multi',
    DATA_CHART_COMPARE: '/api/kb/data/chart/compare',
    PIVOT_TABLE: '/api/kb/pivot/table',
    PIVOT_BUYER_SENTIMENT: '/api/kb/pivot/buyer-sentiment',
    SENTIMENT_TIMING_CONFIG: '/api/kb/sentiment-timing-config',
    // KB 데이터 동기화(토큰/스케줄/즉시실행/상태)
    TOKEN: '/api/kb/token',
    SYNC_SCHEDULE: '/api/kb/sync-schedule',
    SYNC_RUN_NOW: '/api/kb/sync-schedule/run-now',
    SYNC_STATUS: '/api/kb/sync-status',
    // 홈 상단 상태보드(주간/월간 지표)
    STATUS_BOARD: '/api/kb/status-board',
    STATUS_BOARD_UPDATE: '/api/kb/status-board/update',
  },

  // 웹 지역 API
  REGION: {
    LIST: '/api/web-region/list',
    SAVE: '/api/web-region/save',
  },

  // 랭킹 API
  RANKING: {
    LIST: '/api/ranking/list',
  },

  // 인증 API
  AUTH: {
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    SIGNUP: '/api/auth/signup',
  },

  // 즐겨찾기 API
  FAVORITES: {
    LIST: '/api/favorites/list',
    ADD: '/api/favorites/add',
    REMOVE: '/api/favorites/remove',
    GROUPS: '/api/favorites/groups',
    GROUP_ADD: '/api/favorites/groups/add',
    GROUP_UPDATE: '/api/favorites/groups/update',
    GROUP_DELETE: '/api/favorites/groups/delete',
    GROUP_MOVE: '/api/favorites/groups/move',
    GROUP_REMOVE: '/api/favorites/groups/remove-item',
    GROUP_COMPLEXES: '/api/favorites/groups',
  },
};

// HTTP 메서드
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

// API 응답 코드
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};
